import { Grid } from "@material-ui/core";
import LoadingSpinner from "components/LoadingSpinner";
import CustomInput from "../../../../components/CustomInput";
import { washCycleIntervalTypes } from "./enums";

const WashCycleConfig = ({ disabled, cycleFields, onChangeCycleField, isLoading }) => {

    const handleChange = (field, value) => {
        onChangeCycleField(field, value);
    };

    return (
        <>
            <LoadingSpinner loading={isLoading} />
            <Grid container spacing={2} alignItems="center">
                <Grid item xs={2}>
                    <CustomInput
                        disabled={disabled}
                        label="Interval"
                        value={cycleFields?.interval || ''}
                        onChange={val => handleChange('interval', +val)}
                        elementType="input"
                        numberOnly
                        minValue={1}
                        required
                    />
                </Grid>
                <Grid item xs={3}>
                    <CustomInput
                        disabled={disabled}
                        label="Interval Type"
                        value={cycleFields?.intervalType || ''}
                        values={washCycleIntervalTypes}
                        onChange={val => handleChange('intervalType', +val)}
                        elementType="dropdown"
                        showEmpty
                        required
                    />
                </Grid>
                <Grid item xs={3}>
                    <CustomInput
                        disabled={disabled}
                        label="Grace Period (days)"
                        value={cycleFields?.gracePeriodDays || ''}
                        onChange={val => handleChange('gracePeriodDays', +val)}
                        elementType="input"
                        numberOnly
                        minValue={0}
                        required
                    />
                </Grid>
            </Grid>
        </>
    );
};

export default WashCycleConfig;
